import { render, staticRenderFns } from "./zoneDetails.vue?vue&type=template&id=6bf7cb77&"
import script from "./zoneDetails.vue?vue&type=script&lang=js&"
export * from "./zoneDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports